const DEFAULT_MATCH = Symbol('default match');

export const match = (pattern, choices) => (...args) => {
    const defaultRes = choices[DEFAULT_MATCH] || undefined;
    const choice = pattern(...args);
    const res = choices[choice];
    return res ? res(...args) : defaultRes;
};

match.default = DEFAULT_MATCH;
